import { Text } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';

export const AppUnavailable: FunctionComponent = () => (
  <>
    <Text variant="h1">App unavailable</Text>
    <Text variant="lead">
      Your device is offline - please reconnect to the internet and try again.
    </Text>
    <Text variant="lead">
      If you are connected to the internet and the problem persists please contact IT support.
    </Text>
  </>
);
